import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { EmployeeGroupPopup } from './EmployeeGroupTable';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class EmployeeGroup extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            rowData: [],
            colDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            employeeObject: {
                idEmployeeGroup: 0,
                updateStatus: 0,
                empGrpNo: "",
                empGrpName: "",
                grpDesc: "",
                remarks: "",
                e_Date: "",
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                empGrpName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "employee group name"
                        ),
                    },
                ],
            },
        }
    }

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.setState({ isModalOpen: true }, () => {
            this.resetDetailsFields();
            // this.getMasterExpenseAccGroupCount();
        })
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getMasterEmployeeGroupSelectbyID(event.data.idEmployeeGroup);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.employeeObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.employeeObject;
        details[name] = value;
        this.setState({ employeeObject: details });
    }

    getPinnedWidth = (key) => {
        // const pinnedCol = {
        //     "idCashWithdraw": window.innerWidth * 0.06,
        //     "sR.No": window.innerWidth * 0.04,
        //     "employeeName": window.innerWidth * 0.18,
        // }
        // return pinnedCol[key]
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let employeeObject = this.state.employeeObject;
        employeeObject.idEmployeeGroup = 0;
        employeeObject.updateStatus = 0;
        employeeObject.empGrpNo = "";
        employeeObject.empGrpName = "";
        employeeObject.grpDesc = "";
        employeeObject.remarks = "";
        employeeObject.e_Date = "";
        this.setState({
            employeeObject: employeeObject, validState: validState
        }, () => {
            this.getMasterDropdownData();
        });
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                //this.getMasterDropdownData();
            });
        } else {
            // window.location.href = "/Login";
        } setTimeout(() => {
            //this.removeDefaultBorders();
        }, 100);
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Employee Group",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idEmployeeGroup"].includes(key) ? true : false,
                            width: this.getPinnedWidth(key),
                            valueGetter: (params) => params.data[key],
                            // valueFormatter: key.includes("date") || key.includes("invoiceDate")
                            //   ? (params) => {
                            //     if (!params.value) return "";
                            //     return moment(params.value).format("DD-MM-YYYY");
                            //   }
                            //   : undefined,
                            //pinned: ["idBank", "sR.No", "employeeName"].includes(key) ? "left" : null,
                        }));
                        //const priorityColumn = "bankName"; // Replace with the actual column name
                        //const pinnedColumns = dynamicColDefs.filter(col => col.pinned === "left");
                        //const priorityColDef = dynamicColDefs.find(col => col.field === priorityColumn);
                        //const otherColumns = dynamicColDefs.filter(col => col.field !== priorityColumn && !col.pinned);

                        // const updatedColDefs = [
                        //   ...pinnedColumns,
                        //   ...(priorityColDef ? [priorityColDef] : []),
                        //   ...otherColumns,
                        // ];
                        var colName = dynamicColDefs[0].field;
                        // let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs, //updatedColDefs,
                            caption: "Employee Group",
                            colName: colName
                        }, () => {
                            //this.procSelectAllRecord2GridviewSP(id, "Advance Withdraw");
                            //this.getAllDropdownForEmployeeMaster();
                            this.setPermissions(permissions);
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "sR.No": window.innerWidth * 0.05,
            "employeeGroup": window.innerWidth * 0.3,
            "employeeGroupDesc": window.innerWidth * 0.25,
            "remarks": window.innerWidth * 0.15,
        }
        return colwidth[key]
    }

    getMasterDropdownData = () => {
        let request = {
            idCompany: this.state.idCompany,
            idCompanyDivision: 0
        }
        this.masterEntryServices.getMasterDropdownData(request).then((response) => {
            //debugger
            if (response.statusCode === 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.employeeObject;

                let count = allData.filter(item => item.identitys === 'CountOfEmployeeGroup');
                data.empGrpNo = count[0].count > 0 ? (count[0].count + 1) : (0 + 1);

                this.setState({
                    employeeObject: data
                });
            } else {
                //this.usp_Master_EmployeeSelect()
            }
        });
    }

    submit = () => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let details = this.state.employeeObject;
            let requestData = {
                idEmployeeGroup: details.idEmployeeGroup,
                employeeGroup: details.empGrpName,
                employeeGroupDesc: details.grpDesc,
                remarks: details.remarks,
                idCompany: this.state.idCompany,
                idCompanyDivision: 0,
                e_Date: details.e_Date ? details.e_Date : new Date().toISOString(),
                isDeleted: false,
                deletedDate: null
            };
            this.masterEntryServices.submitEmployeeGroupMaster(requestData)
                .then((response) => {
                    if (response.statusCode === 200 && response.responseItem !== null) {
                        let dynamicData = response.responseItem.responseContent;
                        if (dynamicData !== null) {
                            if (dynamicData.errorType === 'Exists') {
                                this.SwalServices.Warning(dynamicData.errorMessage);
                            } else {
                                if (this.state.employeeObject.updateStatus === 1) {
                                    this.SwalServices.Success("Updated successfully.");
                                } else {
                                    this.SwalServices.Success("Saved successfully.");
                                }
                                this.resetDetailsFields();
                                // Call resetFields here after submission
                                this.setState(
                                    { isModalOpen: false },
                                    () => {
                                        this.procSelectAllRecordsSP(); // Fetch latest records
                                    }
                                );
                            }
                        } else {
                            this.procSelectAllRecordsSP();
                        }
                    } else {
                        this.setState(
                            { isModalOpen: false },
                            () => {
                                this.SwalServices.Error(response.message);
                                this.procSelectAllRecordsSP(); // Fetch latest records
                            }
                        );
                    }
                });
        }
    };

    getMasterEmployeeGroupSelectbyID = (id) => {
        this.masterEntryServices.getMasterEmployeeGroupSelectbyID(id).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent[0];
                let data = this.state.employeeObject;
                data.idEmployeeGroup = res.idEmployeeGroup;
                data.updateStatus = 1;
                data.empGrpNo = res.idEmployeeGroup;
                data.empGrpName = res.employeeGroup;
                data.grpDesc = res.employeeGroupDesc;
                data.remarks = res.remarks;
                data.e_Date = res.e_Date;
                //data.isDeleted = false;
                //data.deletedDate = res.;
                this.setState({
                    employeeObject: data,
                    isModalOpen: true
                });
            }
        });
    }

    render() {
        return (
            <div className='tax-structure-master'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                                delete: this.handleDelete,
                            }}
                        />
                        <EmployeeGroupPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            employeeObject={this.state.employeeObject}
                            handleChange={this.handleChange.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            validState={this.state.validState}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 156px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Employee group</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
